import { fromNode, toAlgebra } from 'clownface-shacl-path';
import { sh } from '@tpluscode/rdf-ns-builders';
import { flatten, union } from '../lib/shapePatterns.js';
import PathVisitor from '../lib/PathVisitor.js';
import Shape from './Shape.js';
import { PatternBuilder } from './nodeExpression/NodeExpression.js';
export default class extends Shape {
    constructor(_path, { rules = [], constraints = [] } = {}) {
        super(constraints);
        this._path = _path;
        this.rules = rules;
        this.path = fromNode(_path);
    }
    buildPatterns({ focusNode, variable, rootPatterns }) {
        let pathEnd;
        const visitor = new PathVisitor(variable);
        let patterns;
        if (this.rules.length) {
            pathEnd = variable();
            const rulePatterns = this.rules.map(r => r.buildPatterns({
                focusNode,
                objectNode: pathEnd,
                variable,
                rootPatterns,
                builder: new PatternBuilder(),
            }));
            patterns = union(...rulePatterns);
        }
        else {
            pathEnd = variable.for(focusNode, this._path);
            patterns = visitor.visit(this.path, {
                pathStart: focusNode,
                pathEnd,
            });
        }
        const logical = this.buildLogicalConstraints({ focusNode, variable, rootPatterns });
        patterns = flatten(patterns, logical);
        const nodeContstrains = this.constraints
            .filter((c) => c.type.equals(sh.NodeConstraintComponent))
            .map((nodeConstraint) => {
            const result = nodeConstraint.shape.buildPatterns({
                focusNode: pathEnd,
                variable,
                rootPatterns: [...rootPatterns, ...patterns.whereClause],
            });
            const childConstraints = nodeConstraint.shape.buildConstraints({
                focusNode: pathEnd,
                variable,
                rootPatterns: [...rootPatterns, ...patterns.whereClause],
                valueNode: variable(),
            });
            return {
                childPatterns: {
                    ...result,
                    whereClause: [
                        ...rootPatterns,
                        ...patterns.whereClause,
                        ...result.whereClause,
                    ],
                },
                childConstraints,
            };
        });
        const childPatterns = nodeContstrains.map(c => c.childPatterns);
        return { ...patterns, childPatterns };
    }
    buildConstraints({ focusNode, variable, rootPatterns }) {
        if (!this.constraints.length) {
            return [];
        }
        const valueNode = variable.for(focusNode, this._path);
        const propertyPath = toAlgebra(this._path);
        const constraints = this.constraints.flatMap(c => c.buildPatterns({
            focusNode,
            valueNode,
            propertyPath,
            variable,
            rootPatterns,
        }));
        if (constraints.length === 0) {
            return [];
        }
        return [{
                type: 'bgp',
                triples: [{
                        subject: focusNode,
                        predicate: propertyPath,
                        object: valueNode,
                    }],
            },
            ...constraints];
    }
}
